module.exports = __webpack_public_path__ + "img/GM50-02.141d55d5.jpg";